import { DialogClose } from '@radix-ui/react-dialog';
import { ReactNode } from 'react';

import { Button } from '@/components/ui/button';
import { DialogFooter } from '@/components/ui/dialog';
import { ScrollArea } from '@/components/ui/scroll-area';
import { cn } from '@/utils/cn';

interface SettingsHeaderProps {
  title: string;
  description: string;
  className?: string;
}

export function SettingsHeader({
  title,
  description,
  className,
}: SettingsHeaderProps) {
  return (
    <div className="flex flex-col space-y-1.5 p-6 pb-4 text-center sm:text-left">
      <h2
        className={cn(
          'text-lg font-semibold leading-none tracking-tight',
          className,
        )}
      >
        {title}
      </h2>
      <p className="text-sm text-muted-foreground">{description}</p>
    </div>
  );
}

interface SettingsFormWrapperProps {
  children: ReactNode;
  onSubmit: (e: React.FormEvent) => void;
  isPending: boolean;
  isDirty: boolean;
  isValid: boolean;
  submitLabel: string;
}

export function SettingsFormWrapper({
  children,
  onSubmit,
  isPending,
  isDirty,
  isValid,
  submitLabel,
}: SettingsFormWrapperProps) {
  return (
    <form onSubmit={onSubmit} className="flex grow flex-col overflow-hidden">
      <ScrollArea className="flex max-h-full flex-col">
        <div className="grid items-start gap-4 px-6 py-4 pt-2">{children}</div>
      </ScrollArea>
      <DialogFooter className="mt-auto gap-2 border-t p-6 sm:gap-0">
        <DialogClose asChild>
          <Button type="button" variant="outline">
            Cancel
          </Button>
        </DialogClose>
        <Button type="submit" disabled={isPending || !isDirty || !isValid}>
          {isPending ? 'Saving...' : submitLabel}
        </Button>
      </DialogFooter>
    </form>
  );
}
